import React from 'react';
import { trackAddToCart } from '../hooks/useMetaPixel';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  ariaLabel: string;
  className?: string;
}
export function CtaButton({
  href,
  children,
  ariaLabel,
  className = ''
}: CtaButtonProps) {
  const isShopifyLink = href.includes('simplementemejor.com');
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isShopifyLink) {
      e.preventDefault();
      trackAddToCart();
      // Small delay to ensure pixel fires before navigating away
      setTimeout(() => {
        window.location.href = href;
      }, 300);
    }
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-2.5 font-body font-bold py-5 px-10 rounded-full border-none cursor-pointer no-underline relative overflow-hidden tracking-wide w-full max-w-[520px] text-negro-carbon transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] hover:-translate-y-[3px] hover:scale-[1.02] active:translate-y-0 active:scale-[0.99] ${className}`} style={{
    background: 'linear-gradient(135deg, #C9A84C 0%, #A68A2E 100%)',
    boxShadow: '0 6px 30px rgba(201, 168, 76, 0.5)',
    fontSize: 'clamp(1rem, 2.5vw, 1.15rem)'
  }} aria-label={ariaLabel} data-id="element-26">
      {/* Shimmer overlay */}
      <span className="absolute top-0 -left-full w-full h-full transition-[left] duration-500 ease-in-out group-hover:left-full pointer-events-none" style={{
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)'
    }} data-id="element-27" />
      <span className="relative z-10" data-id="element-28">{children}</span>
      <span className="relative z-10 text-xl transition-transform duration-300 group-hover:translate-x-1.5" data-id="element-29">
        →
      </span>
    </a>;
}